import { useEffect, useReducer } from 'react';

import {
    STATUS_CHANGE_NOTE_ACTIONS,
    STATUS_CHANGE_NOTE_STATUSES,
} from '~/components/StatusChangeNote/constants/statusChangeNote';
import {
    initialStatusChangeNoteState,
    statusChangeNoteReducer,
} from '~/components/StatusChangeNote/reducers/statusChangeNoteReducer';

export function useStatusChangeNote({ open, prefill }: { open: boolean; prefill: string }) {
    const [state, dispatch] = useReducer(statusChangeNoteReducer, initialStatusChangeNoteState);

    useEffect(() => {
        if (!open) dispatch({ type: STATUS_CHANGE_NOTE_ACTIONS.RESET });
    }, [open]);

    const isEnabled = state.status !== STATUS_CHANGE_NOTE_STATUSES.CLOSED;
    let content = '';
    if (state.status === STATUS_CHANGE_NOTE_STATUSES.EDITED) content = state.content;
    else if (state.status === STATUS_CHANGE_NOTE_STATUSES.PREFILLED) content = prefill;

    return {
        content,
        isEnabled,
        noteToSave: content.trim(),
        onContentChange: (nextContent: string) =>
            dispatch({ content: nextContent, type: STATUS_CHANGE_NOTE_ACTIONS.CONTENT_CHANGED }),
        onToggle: (checked: boolean) => dispatch({ checked, type: STATUS_CHANGE_NOTE_ACTIONS.TOGGLED }),
    };
}
